import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CategoryNav = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API}/categories?ativo=true`);
      setCategories(response.data);
    } catch (error) {
      console.error('Erro ao carregar categorias:', error);
    }
  };

  const handleCategoryClick = (slug) => {
    navigate(`/categoria/${slug}`);
  };

  return (
    <div className="category-nav-wrapper" style={{ backgroundColor: '#fff', padding: '0.75rem 0', borderBottom: '1px solid #eee' }}>
      <div className="category-nav-container" style={{
        display: 'flex',
        gap: '0.5rem',
        overflowX: 'auto',
        scrollBehavior: 'smooth',
        WebkitOverflowScrolling: 'touch',
        padding: '0 0.75rem',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }}>
        <button
          onClick={() => navigate('/')}
          style={{
            backgroundColor: '#000',
            color: '#fff',
            border: 'none',
            padding: '0.4rem 0.85rem',
            borderRadius: '4px',
            fontSize: '0.8rem',
            fontWeight: '500',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            transition: 'opacity 0.2s ease',
            flexShrink: 0
          }}
          onMouseEnter={(e) => e.target.style.opacity = '0.8'}
          onMouseLeave={(e) => e.target.style.opacity = '1'}
          data-testid="category-nav-home"
        >
          Todos
        </button>
        {categories.map(category => (
          <button
            key={category.id}
            onClick={() => handleCategoryClick(category.slug)}
            style={{
              backgroundColor: '#000',
              color: '#fff',
              border: 'none',
              padding: '0.4rem 0.85rem',
              borderRadius: '4px',
              fontSize: '0.8rem',
              fontWeight: '500',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              transition: 'opacity 0.2s ease',
              flexShrink: 0
            }}
            onMouseEnter={(e) => e.target.style.opacity = '0.8'}
            onMouseLeave={(e) => e.target.style.opacity = '1'}
            data-testid={`category-nav-${category.slug}`}
          >
            {category.nome}
          </button>
        ))}
      </div>
      <style>{`
        .category-nav-container::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};

export default CategoryNav;
